// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

export const safeStringify = jsonObj => JSON.stringify(jsonObj, getCircularReplacer());

export const get = (object, path, defaultValue) => {
    if (!object) {
        return typeof defaultValue !== 'undefined' ? defaultValue : object;
    }
    let internalObject = object;
    const seg = (path.indexOf('.') !== -1) ? path.split('.') : [path];
    while (internalObject && seg.length) {
        internalObject = internalObject[seg.shift().replace(/[\[\]']+/g, '')];
    }
    return internalObject !== undefined ? internalObject : defaultValue;
};

export const getQueryParam = (out, queryParam) => {
    if (typeof window === 'object') {
        return new URL(window.location.href).searchParams.get(queryParam);
    }
    return get(out, `global.req.query.${queryParam}`);
};

export const isDraft = out => getQueryParam(out, 'draft') === 'true';

export const clone = model => JSON.parse(JSON.stringify(model));

export const getTrackingString = (object, pathToTrackingList, keyValue) => {
    let tracking;
    if (object && pathToTrackingList) {
        const trackingList = get(object, pathToTrackingList, []);
        if (keyValue && Object.keys(keyValue).length) {
            const keys = Object.keys(keyValue);
            const key = keys.length && keys[0];
            const list = trackingList.filter(item => {
                if (item[key] === keyValue[key]) {
                    return true;
                }
            });
            tracking = list.length && list[0];
        } else {
            tracking = trackingList.length && trackingList[0];
        }
    }
    return tracking ? JSON.stringify(tracking) : '';
};

export const isProfilePage = page => {
    const presenceType = get(page, 'modules.PRESENCE_INFORMATION_MODULE.presenceType', '');
    return presenceType === 'BUYER' || presenceType === 'SELLER';
};

export const isProfilePageEdit = page => !!get(page, 'modules.PRESENCE_INFORMATION_MODULE.editProfileAction', null);
